import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { format, parseISO } from "date-fns";
import { useNavigate } from "react-router-dom";

type Props = { procedimento: any };

function IpImportaCard({ procedimento }: Props) {
  const navigate = useNavigate();

  const prettyDate = (value: any) => {
    const aDate = parseISO(value);
    try {
      return format(aDate, "dd/MM/yyyy");
    } catch (err) {
      return "Pendente";
    }
  };
  const getOcorrencias = (item: any, pos: any) => {
    if (item.NewDataSet.OCORRENCIA && item.NewDataSet.OCORRENCIA[pos]) {
      return item.NewDataSet.OCORRENCIA[pos].OCORCAPITULACAO;
    }
  };
  const getMunicipio = (item: any) => {
    if (item.NewDataSet.OCORRENCIA && item.NewDataSet.OCORRENCIA[0]) {
      return item.NewDataSet.OCORRENCIA[0].ENDCMUNICIPIODESC;
    }
  };

  const clickHandler = (id: number) => {
    navigate(`/policial/procedimento/${id}`);
  };
  return (
    <>
      <Card
        sx={{
          minHeight: 250,
          maxHeight: 250,
          display: "flex",
          flexDirection: "column",
          overflow: "no",
          ":hover": {
            boxShadow: 10,
          },
          boxShadow: 2,
          cursor: "pointer",
        }}
        onClick={clickHandler.bind(null, procedimento.id)}
      >
        <CardHeader
          sx={{ pt: 1.6, pb: 0.6 }}
          title={
            <Typography variant="body2" sx={{ pb: 0, fontSize: 16 }}>
              <b>{procedimento.NewDataSet.PROCEDIMENTO.PROCNUMERO}</b>
            </Typography>
          }
          action={
            <Typography
              variant="body2"
              color="secondary.dark"
              sx={{ pb: 0, fontSize: 14 }}
            >
              <b>{procedimento.NewDataSet.PROCEDIMENTO.CATGDESCRICAO}</b>
            </Typography>
          }
          subheader={
            <Typography variant="body2" sx={{ color: "rgb(136, 14, 79)" }}>
              <b>{procedimento.NewDataSet.PROCEDIMENTO.STTSDESCRICAO}&nbsp;</b>
            </Typography>
          }
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            pl: 1,
            pt: 0,
            pb: 0,
            m: 0,
          }}
        >
          <IconButton aria-label="previous">
            <ArrowDownwardIcon />
          </IconButton>
          <Typography variant="body2">
            <b>{prettyDate(procedimento.NewDataSet.PROCEDIMENTO.PROCDATA)}</b>
          </Typography>
          <IconButton aria-label="next">
            <ArrowOutwardIcon />
          </IconButton>
          <Typography variant="body2">
            <b>
              {prettyDate(procedimento.NewDataSet.PROCEDIMENTO.DATALIBERACAO)}
            </b>
          </Typography>
        </Box>
        <CardContent sx={{ pt: 0, pb: 0 }}>
          <Typography variant="body2">
            <>
              {getMunicipio(procedimento) && (
                <small>
                  <br />
                  <b>{getMunicipio(procedimento)}</b>
                </small>
              )}
              {getOcorrencias(procedimento, 0) && (
                <>
                  <br />
                  <small>{getOcorrencias(procedimento, 0)}</small>
                </>
              )}
              {getOcorrencias(procedimento, 1) && (
                <>
                  <br />
                  <small>{getOcorrencias(procedimento, 1)}</small>
                </>
              )}
            </>
          </Typography>
        </CardContent>
      </Card>
    </>
  );
}

export default IpImportaCard;
